import React, { useState } from 'react';
import { auth } from '../firebaseConfig';
import { updateProfile } from 'firebase/auth';
import './comic.css';

// Blocking screen shown whenever the signed-in account has no displayName
// set on its Firebase Auth profile yet -- covers both existing accounts
// (created before this feature existed) and, as a fallback, any signup that
// somehow reaches here without one. Mirrors ProfileGate.jsx's "block until
// X is set up" pattern. onSet is called with the trimmed username on
// success so the caller (App.js) can update its own state immediately
// rather than waiting on Firebase's auth-state listener to catch up.
const UsernameGate = ({ onSet }) => {
  const [username, setUsername] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = username.trim();
    if (!trimmed || submitting) return;

    setSubmitting(true);
    setError(null);
    try {
      await updateProfile(auth.currentUser, { displayName: trimmed });
      onSet(trimmed);
    } catch (err) {
      setError("Couldn't save your username. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="comic-panel comic-panel--outer-active">
      <h2 className="comic-title" style={{ fontSize: "26px" }}>Choose a Username</h2>
      <p className="comic-subtitle">One more thing before you start training -- what should we call you?</p>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="comic-input"
          style={{ width: "100%" }}
          maxLength={40}
          autoFocus
        />
        <button
          type="submit"
          disabled={submitting || !username.trim()}
          className="comic-btn comic-btn--go"
        >
          {submitting ? "Saving..." : "Continue"}
        </button>
        {error && <div className="comic-alert-bubble">{error}</div>}
      </form>
    </div>
  );
};

export default UsernameGate;
